import type { PathwaySectionResponse } from '@routes/sidebar/admin-center/creator/___pages___/pathways/api/creatorPathways.api.ts';

export const getPathwayElementIds = (sections: PathwaySectionResponse[]): string[] =>
    sections.flatMap((section) => [
        ...section.elements.map((element) => element.elementAdmin.elementAdminInfo.id.toString()),
        ...getPathwayElementIds(section.subSections),
    ]);
